import React from "react"
import { Flex } from "@capioweb/ui-components"
import { ContentAreaProperty, XhtmlString } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { PageBaseProps } from "../../components/Core/pageBase"
import {
	BlockResolver,
	BreadcrumbsBlock,
	CommonHeroBlock,
} from "../../components"
import { EpiContext } from "../../context"
import { shouldRender } from "../../utils"
import { useLocation } from "react-router-dom"
import { scrollToAnchor } from "../../utils/scrollToAnchor"

interface CapioNewsCategoryPageProps extends PageBaseProps {
	mainContentArea: ContentAreaProperty
	header: StringProperty
	preamble: XhtmlString
}

const CapioNewsCategoryPage: React.FC<CapioNewsCategoryPageProps> = (props) => {
	const { editMode } = React.useContext(EpiContext)

	const { hash } = useLocation()

	const id = decodeURI(hash.substring(1))

	const el = document?.getElementById(id)

	React.useEffect(() => {
		if (el) {
			//Scroll to anchorID position if it exists
			scrollToAnchor(el)
		}
	}, [el]) //UseEffect will run again when 'el' is ready

	return (
		<Flex display="block" w={1}>
			<BreadcrumbsBlock items={...props.breadcrumb} />
			<CommonHeroBlock heading={props.header} preamble={props.preamble} />
			{shouldRender(editMode.inEditMode, props.mainContentArea?.value) && (
				<div data-epi-edit="mainContentArea">
					<BlockResolver blocks={props.mainContentArea?.value} />
				</div>
			)}
		</Flex>
	)
}

export { CapioNewsCategoryPage }
